export const environment = {
  production: false,
  staging: true,
  testing: false,
  apiHost: 'https://moxi-api.masena.dev/api',
  webSocketHost: 'wss://moxi-api.masena.dev/api',
  googleMapsLibraries: ['places']
};
